'use strict';
import angular from 'angular';

angular.module('steps.services', [])

    .factory('StepsService', ['IORestangular', '$q', function(IORestangular, $q){
        var steps = IORestangular.all('workflows/workflowStep');

        var getSteps = function(){
            return steps.getList();
        };

        var addStep = function(step){
            return steps.customPOST(step, undefined, undefined, undefined);
        };

        var removeStep = function(step){
            return steps.remove(step);
        };

        var updateStep = function(step){
            return steps.customPUT(undefined, undefined, step, undefined);
        };

        return {
            getSteps : getSteps,
            addStep : addStep,
            updateStep : updateStep,
            removeStep : removeStep
        };

    }])
    .factory('StepGroupService', ['IORestangular', function(IORestangular) {
        var stepGroups = IORestangular.all('workflows/workflowStepGroup');
        var stepsRefs = IORestangular.all('workflows/workflowStepGroupXrefs');

        var self = {};

        var getStepGroups = function(all) {
            return stepGroups.getList(all);
        };

        var getStepsXrefs = function(id) {
            return stepsRefs.customGET(undefined, id);
        }

        var addStepGroup = function(group) {
            return stepGroups.post(group, undefined, undefined, undefined);
        };

        var updateStepGroup = function(group) {
            return stepGroups.customPUT(undefined, undefined, group, undefined);
        };

        var deleteStepGroup = function(group) {
            return stepGroups.remove(group);
        };

        var addStepToGroup = function(step){
            // first param sending parameters with hidden body
            // Third param sending parameters with url
            return stepsRefs.customPOST(step, undefined, undefined, undefined);
        }

        return {
            getStepGroups: getStepGroups,
            addStepGroup: addStepGroup,
            updateStepGroup: updateStepGroup,
            deleteStepGroup: deleteStepGroup,
            getStepsXrefs: getStepsXrefs,
            addStepToGroup: addStepToGroup
        };

    }]);